export default __webpack_public_path__ + "static/media/photo--sm--11.e5d0dad9.jpg";